<div class="barra-progresso-wrapper flex-1">
  <div class="container fundo">
    <div class="progress" [style.width.%]="progresso"></div>
  </div>
  <div class="container texto flex-row center-center">
    <span>{{ progresso ? math.floor(progresso) : 0 }}% Lido</span>
    <span *ngIf="tempoRestante">
      <span>, Restam </span>
      <ng-container
        *ngIf="
          tempoRestante.segundos &&
            !tempoRestante.minutos &&
            !tempoRestante.horas;
          else elseTemplate
        "
      >
        <span>{{ tempoRestante.segundos || 0 }}s</span>
      </ng-container>
      <ng-template #elseTemplate>
        <span *ngIf="tempoRestante.horas">{{ tempoRestante.horas || 0 }}h</span>
        <span *ngIf="tempoRestante.horas && tempoRestante.minutos">, </span>
        <span *ngIf="tempoRestante.minutos"
          >{{ tempoRestante.minutos || 0 }}m</span
        >
      </ng-template>
    </span>
  </div>
</div>
